import styles from './CollectionHeader.module.scss';
import SearchBox from '@casops/components/inputs/search-box/SearchBox';
import { ReactElement } from 'react';
import classNames from 'classnames';
import CollectionSummary, { CollectionSummaryProps } from '../collection-summary/CollectionSummary';

export interface CollectionHeaderProps extends CollectionSummaryProps {
  sliceKey: string;
  // All actions can be configured on a per-collection bases. E.g. Create, Edit, Upload, Export, Filters, Etc.
  actions?: ReactElement | null;
  showSummary?: boolean;
}

export function CollectionHeader({
  sliceKey,
  modelName,
  secondaryModelName,
  countAll,
  apiResultLimit,
  filterProps,
  actions,
  showSummary = true,
}: CollectionHeaderProps): ReactElement {
  return (
    <header className={classNames(styles.header, { [styles['header--showSummary']]: showSummary })}>
      {showSummary && (
        <CollectionSummary
          filterProps={filterProps}
          modelName={modelName}
          secondaryModelName={secondaryModelName}
          countAll={countAll}
          apiResultLimit={apiResultLimit}
        />
      )}

      <div className={classNames(styles.actions, { [styles['actions--compact']]: !showSummary })}>
        {actions}

        <div className={classNames(styles.search, { [styles['search--stretch']]: !showSummary })}>
          <SearchBox sliceKey={sliceKey} />
        </div>
      </div>
    </header>
  );
}

export default CollectionHeader;
